import axios from './axios';
const ENDPOINT = '/technicians/calendar';
export default function getCalendar(vehicleTypeId = null) {
    return axios.post(ENDPOINT, {
        minDate: new Date().toISOString(),
        vehicleTypeId: vehicleTypeId
    });
}